export class DossierSettings{
	ID:number = 0;
	HideSaleModifiedHistoryEvent:boolean = false
	HideCopyrightOnSales:boolean = false;
	DeletedSalesDisabled:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.HideSaleModifiedHistoryEvent = data.HideSaleModifiedHistoryEvent;
		this.HideCopyrightOnSales = data.HideCopyrightOnSales;
		this.DeletedSalesDisabled = data.DeletedSalesDisabled;
	}

	public getJSON(){
		return {
			ID: this.ID,
			HideSaleModifiedHistoryEvent: this.HideSaleModifiedHistoryEvent,
			HideCopyrightOnSales: this.HideCopyrightOnSales,
			DeletedSalesDisabled: this.DeletedSalesDisabled
		};
	}
}
